import { doesNotHaveExpand, get } from "@insite/client-framework/Services/ApiService";
import { GetInvoiceApiParameter, GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";
import { InvoiceCollectionModel, InvoiceModel } from "@insite/client-framework/Types/ApiModels";

const invoicesUrl = "api/v2/invoicehistory/InvoiceHistoryCollection";
const invoiceUrl = "api/v2/invoicehistory/InvoiceNoBasedInvoiceHistory";

function cleanInvoice(invoice: InvoiceModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    invoice.id = invoice.invoiceNumber;
    if (doesNotHaveExpand(parameter, "invoiceLines")) {
        invoice.invoiceLines = null;
    }
}

export async function getInvoicesFromERP(parameter: GetInvoicesApiParameter) {
    const invoices = await get<InvoiceCollectionModel>(invoicesUrl, parameter);
    invoices.invoices?.forEach(o => cleanInvoice(o));
    return invoices;
}

export async function getInvoiceFromERP(parameter: GetInvoiceApiParameter) {
    const { invoiceNumber, ...newParameter } = parameter;
    const invoice = await get<InvoiceModel>(`${invoiceUrl}/${invoiceNumber}`, newParameter);
    cleanInvoice(invoice, parameter);
    return invoice;
}
